<div class="v4-card flex flex-row justify-between items-center p-6 border-c-gb border border-solid rounded-[10px]">
  <div class="flex-1 overflow-hidden">
    <div class="text-l mb-2">{{ title }}</div>
    <div class="text-s" *ngIf="content">{{ content }}</div>
    <ng-content select=".card_content"></ng-content>
  </div>
  <ng-content select=".card_button"></ng-content>
</div>
